import React, { useState } from 'react'
import IngredientCategoryPicker from './components/IngredientCategoryPicker'
import CategoryIngredientToolbar from './components/CategoryIngredientToolbar'
import { useAppSelector } from 'src/store'
import { Ingredient } from 'src/types/types'
import './IngredientsToolbar.scss'

const IngredientsToolbar = () => {

    const [category, setCategory] = useState(0)
    const ingredients = useAppSelector(x => x.recipes.allIngredients)

    let categoryIngredients: Ingredient[] = []
    if (ingredients) {
        categoryIngredients = ingredients.filter(x => x.category === category)
    }

    return (
        <>
            <IngredientCategoryPicker
                currentCategory={category}
                ingredients={ingredients}
                onChange={setCategory}
            />
            <CategoryIngredientToolbar
                category={category}
                ingredients={categoryIngredients}
            />
        </>
    )
}

export default IngredientsToolbar